//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import CheckboxMultiSelect from '../../components/inputs/CheckboxMultiSelect';
import TopoTitleComponente from '../../components/PageTitle/TopoTitleComponente';
import ListagemPage from '../../components/templates/ListagemPage';
import TopoListagem from '../../components/Topo/TopoListagem';
import { objectsConstants } from '../../_constants/objects.constants';
import { tableHelper } from '../../_helpers/tableHelper';
import { pacienteService } from '../../_services/paciente.service';
import PacienteListFilter from './PacienteListFilter';

const columns = [
  {
    path: 'foto',
    title: '',
    isKey: false,
    isAvatar: true,
    dataSort: false,
    propsMidiaId: 'foto.id',
    className: 'avatar-list',
    width: '100px',
    notExport: true,
  },
  {
    path: 'id',
    pathFilter: 'id',
    title: 'Código',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    width: '100px',
  },
  {
    path: 'nome',
    pathFilter: 'nome',
    title: 'Nome do paciente',
    isKey: false,
    dataSort: true,
    className: 'nomeProprio column-bold',
    width: '20%',
  },

  {
    path: 'nomeSocial',
    pathFilter: 'nomeSocial',
    title: 'Nome social do paciente',
    isKey: false,
    dataSort: true,
    className: 'nomeProprio',
    width: '20%',
  },
  {
    path: 'cpfCnpj',
    pathFilter: 'cpfCnpj',
    title: 'CPF',
    isKey: true,
    dataSort: true,
    width: '10%',
  },
  {
    path: 'email',
    pathFilter: 'email',
    title: 'E-mail',
    isKey: false,
    dataSort: true,
    width: '20%',
  },
  {
    path: 'telefonesStr',
    pathFilter: 'telefonesStr',
    title: 'Telefones:',
    isKey: false,
    dataSort: true,
    width: '30%',
  },
];

const endPoint = '/paciente/novo';
const endPointView = '/paciente/';
class PacienteListagemPage extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);
    let fields = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.path;
      }
    );
    let labels = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.title;
      }
    );
    this.state = {
      labels,
      fields,
    };
  }

  handleRowClick = (row: e) => {
    this.props.history.push(endPointView + row.id);
  };

  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);
    // this.props.history.push({
    //   pathname: endPoint,
    //   state: {
    //     titlePage: 'Paciente',
    //   },
    // });
  };

  render() {
    const tableColumn = _.map(columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={tableHelper.renderCustom}
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle={objectsConstants.TITULO_PAGINA_PACIENTES}
          subTitle=" "
          canBack={false}
        />
        <TopoListagem
          securityActionDo={objectsConstants.VIEW}
          securityActionOn={objectsConstants.CRUD_PACIENTE_EDITAR}
          buttonActionClassName={'btn-light'}
          buttonAction={() => {
            this.handleNewButton();
          }}
          securityActionIcon={'icon-btn-add'}
          securityActionName={'Novo paciente'}
        ></TopoListagem>
        <CheckboxMultiSelect></CheckboxMultiSelect>
        <ListagemPage
          title={'Pacientes'}
          showNewButton={false}
          delete={() => { }}
          service={pacienteService}
          defaultOrder={'nome'}
          defaultDirection={'asc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={PacienteListFilter}
          controller="api/paciente"
          fields={this.state.fields}
          labels={this.state.labels}
          columns={columns}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(PacienteListagemPage);
